module.exports = __webpack_public_path__ + "img/arrow_down_2.510c83b3.svg";